<div class="container">
  <div class="tabs" #tabsContainer>
    <div class="circle-indicator" #indicator></div>
    <ng-container *ngIf="tabs?.length > 0">
      <div
        class="tab ms-0"
        *ngFor="let tab of tabs; let i = index"
        [class.active]="selectedIndex === i"
        [ngStyle]="tabStyle"
        (click)="selectTab(i)"
      >
        @if (tab === 'wallet') {
          <fgbcl-wallet-text-with-badge [count]="unredeemedCount">
            <label class="pe-0">{{ TAB_CONFIG[tab].label | translate }}</label>
          </fgbcl-wallet-text-with-badge>
        } @else {
          <label>{{ TAB_CONFIG[tab].label | translate }}</label>
        }
      </div>
    </ng-container>
  </div>
</div>
